import React from 'react';
import { motion } from 'framer-motion';
import { useRecentCalls } from './hooks/useRecentCalls';
import { RecentCallsHeader } from './components/RecentCallsHeader';
import { RecentCallsFilters } from './components/RecentCallsFilters';
import { RecentCallsTable } from './components/RecentCallsTable';
import { Pagination } from '../../../../shared/components/molecules/Pagination/Pagination';

export function RecentCalls() {
  const {
    sessions,
    pagination,
    isLoading,
    isFetching,
    page,
    searchQuery,
    setSearchQuery,
    days,
    setDays,
    selectedUserId,
    setSelectedUserId,
    isOrgAdmin,
    teamMembers,
    handlePageChange,
    handleSelectCall
  } = useRecentCalls();

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      style={{
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxSizing: 'border-box'
      }}
    >
      {/* ── Page Header ── */}
      <RecentCallsHeader />

      {/* ── Filters Bar ── */}
      <div id="tour-calls-filters">
        <RecentCallsFilters
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          days={days}
          setDays={setDays}
          selectedUserId={selectedUserId}
          setSelectedUserId={setSelectedUserId}
          isOrgAdmin={isOrgAdmin}
          teamMembers={teamMembers}
        />
      </div>

      {/* ── Calls Table ── */}
      <div id="tour-calls-table">
        <RecentCallsTable
          sessions={sessions}
          isLoading={isLoading || isFetching}
          isOrgAdmin={isOrgAdmin}
          onSelectCall={handleSelectCall}
        />
      </div>

      {/* ── Pagination Controls ── */}
      <Pagination
        page={page}
        total={pagination.total || sessions.length}
        limit={pagination.limit || 10}
        onPageChange={handlePageChange}
        theme="admin"
        itemName="calls"
      />
    </motion.div>
  );
}
